<template>
    <div class="Input InputRadioIcons">
        <el-radio-group v-model="localModel" >
            <el-radio-button class="InputRadioIcons__item"
                             v-if="key != '_config'"
                             v-for="(item, key) in items"
                             :label="key"
                             :key="key"
                             tabindex="0">

                <div v-if="item['_config'].icon == 'client'" class="InputRadioIcons__icon" v-on:click="scrollTo()">
                    <div class="simple-svg-wrapper">
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
                          y="0px" viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve">
                          <path fill="#333333" d="M42.5,41.2h14.7c0.9,0,1.5-0.6,1.5-1.4V29.6c0-0.8-0.7-1.5-1.5-1.5H42.5c-0.8,0-1.5,0.7-1.5,1.5v10.2
                          C41.1,40.6,41.8,41.2,42.5,41.2z M44,30.9h11.8v7.3H44V30.9z" />
                          <path fill="#333333" d="M98,28.7c-0.1-0.4-0.3-0.7-0.6-0.9l-8.3-6L61.5,1.6c-0.6-0.4-1.4-0.4-1.8,0.1L33.5,21.4c-0.1,0-0.1,0-0.1,0.1
                          l-8.1,6.1l-0.1,0.1c-0.7,0.5-0.8,1.5-0.4,2.1c0.2,0.3,0.6,0.5,1,0.6c0.4,0.1,0.8,0,1.1-0.3l3.7-2.9v28.5h1.6h0l0,0
                          c0.4,0,0.9,0,1.3,0.1V25.1L60.8,4.7L87.1,24l1.5,1.1V68l-5.1,0.7v-23c0-0.8-0.7-1.5-1.5-1.5H64.9c-0.8,0-1.5,0.7-1.5,1.5v25.7
                          l-1.9,0.3c0.4,0.4,0.8,0.8,1.2,1.3c0.3,0.4,0.6,0.9,0.8,1.3l26.9-3.8c0.7-0.2,1.2-0.8,1.2-1.5V27.2l3.8,2.7l0.2,0.1l0.1,0.1
                          c0.3,0.2,0.7,0.3,1.1,0.2c0.4-0.1,0.7-0.3,0.9-0.6C98,29.5,98,29.1,98,28.7z M80.6,69L66.4,71V47.1h14.2V69z" />
                          <path fill="#CF2B4C" d="M30.6,58.7H18.5c0,0,0,0,0,0c-2,0-3.8,0.9-5.1,2.4l-7.8,9.8c-0.8,1-1.3,2.3-1.3,3.7v11.2c0,2.1,1.7,3.8,3.8,3.8
                          h1.2c0.7,3.5,3.8,6,7.4,6c0.4,0,0.7,0,1.1-0.1c3.2-0.5,5.7-2.8,6.3-5.9h16.3c0.4,1.8,1.4,3.4,2.9,4.5c1.3,1,2.9,1.5,4.5,1.5
                          c0.4,0,0.7,0,1.1-0.1c3.2-0.5,5.7-2.8,6.3-5.9h2.7c2.1,0,3.8-1.7,3.8-3.8v-6.5c0-1.7-0.6-3.3-1.5-4.6c-0.8-1.1-1.9-1.9-3.1-2.5
                          c-1-0.4-2-0.7-3.1-0.7h-6.1l-0.9,0L36.9,60.8c-0.9-1-2.1-1.6-3.4-1.9c-0.4-0.1-0.9-0.1-1.4-0.2H30.6z M27.8,61.8v9.7H15.7l8-9.7
                          H27.8z M21.2,89.1c-0.4,2.1-2.3,3.6-4.4,3.6c-0.3,0-0.6,0-0.9-0.1c-1.7-0.4-3.1-1.7-3.5-3.5c-0.1-0.6-0.1-1.2,0-1.8
                          c0.3-1.2,0.9-2.2,2-2.8c0.7-0.5,1.6-0.7,2.4-0.7c0.3,0,0.6,0,0.9,0.1c1.7,0.4,3.1,1.7,3.5,3.5C21.3,87.8,21.3,88.4,21.2,89.1z
                          M52.2,89.1c-0.5,2.1-2.3,3.6-4.4,3.6c-0.3,0-0.6,0-0.9-0.1c-1.7-0.4-3.1-1.7-3.5-3.5c-0.1-0.6-0.1-1.2,0-1.9
                          c0.4-2.1,2.3-3.6,4.4-3.6c0.3,0,0.6,0,0.9,0.1c1.7,0.4,3.1,1.7,3.5,3.5C52.3,87.8,52.3,88.4,52.2,89.1z M54,74.6
                          c0.9,0,1.7,0.3,2.4,0.7c1.4,0.8,2.3,2.3,2.3,4v6.5c0,0.4-0.4,0.8-0.8,0.8h-2.7c-0.4-1.8-1.4-3.4-2.9-4.5c-1.3-1-2.9-1.5-4.5-1.5
                          c-0.4,0-0.7,0-1.1,0.1c-3.2,0.5-5.7,2.8-6.3,5.9H24.1c-0.4-1.8-1.4-3.4-2.9-4.5c-1.3-1-2.9-1.5-4.5-1.5c-0.4,0-0.7,0-1.1,0.1
                          c-3.2,0.5-5.7,2.8-6.3,5.9H8.1c-0.4,0-0.8-0.4-0.8-0.8V74.6c0-0.6,0.2-1.3,0.6-1.7l7.8-9.8c0.7-0.8,1.6-1.3,2.7-1.3c0,0,0,0,0,0h1.3
                          L9.2,74.6h21.4h3h6.2H54z M34.7,62.9l8.1,8.6h-9.3h-2.7v-9.7h1.4c0.5,0,0.9,0.1,1.4,0.3C34,62.3,34.4,62.5,34.7,62.9z" />
                        </svg>
                    </div>
                </div>

                <div v-if="item['_config'].icon == 'prospect'" class="InputRadioIcons__icon" v-on:click="scrollTo()">
                    <div class="simple-svg-wrapper">
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
                          y="0px" viewBox="0 0 64 59.6" style="enable-background:new 0 0 64 59.6;" xml:space="preserve">
                          <g>
                            <path fill="#333333" d="M46.7,21.5c-5.5,0-9.9-4.4-9.9-9.9s4.4-9.9,9.9-9.9s9.9,4.4,9.9,9.8C56.5,17.1,52.2,21.5,46.7,21.5z M46.7,4.5
                            c-3.9,0-7.1,3.1-7.1,7.1c0,3.9,3.1,7.1,7.1,7.1s7.1-3.1,7.1-7.1l0,0C53.7,7.7,50.6,4.5,46.7,4.5z" />
                            <g>
                              <path fill="#333333" d="M36.3,33.7c2.3-3.3,6.1-5.5,10.4-5.5c5.7,0,10.7,3.9,12.2,9.3l-17.5,1.6c0.6,0.8,1.1,1.8,1.6,2.6L62.2,40
                              L62,38.5c-1.1-7.6-7.6-13.2-15.3-13.2c-5.3,0-9.9,2.7-12.6,6.8C34.8,32.6,35.6,33.1,36.3,33.7z" />
                            </g>
                            <path fill="#CF2C4C" d="M20.4,29.3c-6.7,0-12.2-5.5-12.2-12.2S13.7,5,20.4,5s12.2,5.5,12.2,12.2S27.2,29.3,20.4,29.3z M20.4,7.9
                            c-5.2,0-9.3,4.2-9.3,9.3s4.2,9.3,9.3,9.3s9.3-4.2,9.3-9.3S25.6,7.9,20.4,7.9z" />
                          </g>
                          <g>
                            <polygon fill="#FFFFFF" points="19.4,38.8 16.8,43.1 19.4,47 17,57.9 25.5,57.1 23,47 26.2,43.1 23,38.8 	" />
                            <g>
                              <path fill="#CF2C4C" d="M15.9,49.6L4.7,50.8c0.8-9,8.4-16,17.6-16c7.8,0,14.7,5.2,16.9,12.6l-12.8,1.2l0.7,2.7l15.7-1.6l-0.3-1.4
                              C40.5,38.8,32,31.9,22.3,31.9C11,31.9,1.8,41,1.8,52.4V54l13.4-1.3L15.9,49.6z" />
                              <polygon fill="#CF2C4C" points="18.9,49.3 18.2,52.3 24.2,51.7 23.5,48.9 		" />
                            </g>
                          </g>
                          <g>
                            <polygon fill="#CF2C4C" points="19.4,38.8 16.8,43.1 19.4,47 17,57.9 25.5,57.1 23,47 26.2,43.1 23,38.8 	" />
                          </g>
                        </svg>
                    </div>
                </div>

                <div v-if="item['_config'].icon == 'sante'" class="InputRadioIcons__icon" v-on:click="scrollTo()">
                    <div class="simple-svg-wrapper">
                        <svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
                          y="0px" viewBox="0 0 60 55" style="enable-background:new 0 0 60 55;" xml:space="preserve">
                          <g transform="matrix(1 0 0 1 -74 -86 )">
                            <path fill="#CE0E4A" d="M105.7,139.9c-0.4,0.3-1,0.5-1.7,0.5s-1.3-0.2-1.7-0.6c-5.7-4.5-11.1-9.5-16.1-14.8
                            c-8.1-8.8-12.2-16.2-12.2-22.1c0-9.3,7.5-16.8,16.7-16.8c5,0,9.8,2.3,13,6.2c0.1,0.2,0.4,0.2,0.6,0.1l0.1-0.1
                            c5.8-7.2,16.3-8.2,23.5-2.4c3.9,3.2,6.1,7.9,6.1,13c0,6.1-4.1,13.7-12.2,22.4C116.8,130.6,111.4,135.5,105.7,139.9z M102.2,93.6
                            c-2.8-3.5-7-5.6-11.5-5.6c-8.2,0.1-14.8,6.7-14.8,14.9c0,13,22.9,31.8,27.6,35.4c0.3,0.3,0.8,0.3,1.1,0
                            c4.6-3.5,27.5-21.8,27.5-35.4c0-8.2-6.6-14.8-14.8-14.8c-4.5,0-8.7,2-11.5,5.5c-0.8,1-2.2,1.2-3.3,0.3
                            C102.4,93.8,102.3,93.7,102.2,93.6z" />
                          </g>
                          <g>
                            <g transform="matrix(1 0 0 1 -93 -101 )">
                              <path fill="#1D1D1B" d="M128.5,129.5c0,0.2-0.3,0.2-0.6,0.2c-0.1,0-0.1,0-0.2,0c-0.3-0.1-0.6-0.3-0.7-0.7l-2.7-9.6l-2.7,6.2
                              c-0.2,0.5-0.8,0.7-1.3,0.5c-0.1,0-0.1-0.1-0.2-0.1l-2.7-1.9l-2.9,4.6c-0.3,0.4-0.9,0.6-1.3,0.3c-0.4-0.2-0.6-0.9-0.3-1.3l3.4-5.4
                              c0.3-0.4,0.9-0.6,1.3-0.3l2.6,1.8l3.3-7.6c0.2-0.5,0.8-0.7,1.3-0.5c0.3,0.1,0.4,0.3,0.5,0.6l3,10.6l3.2-3.4
                              c0.3-0.4,0.9-0.5,1.3-0.2c0.4,0.3,0.5,0.9,0.2,1.3c-0.1,0.1-0.1,0.1-0.1,0.2L128.5,129.5z" />
                            </g>
                            <g transform="matrix(1 0 0 1 -112 -108 )">
                              <path fill="#1D1D1B" d="M151.3,132.4h-0.1c-0.5,0-1-0.5-0.9-1.2c0-0.6,0.5-1.1,1-1.1h12.8c0.5,0,1,0.4,1,1.1c0,0.6-0.5,1.1-1,1.1
                              H151.3z" />
                            </g>
                            <g transform="matrix(1 0 0 1 -84 -113 )">
                              <path fill="#1D1D1B" d="M94.9,141.2h-0.1c-0.5,0-0.9-0.5-0.9-1.2c0.1-0.7,0.4-1.1,1-1.1h9.9c0.5,0,0.9,0.5,0.9,1.1
                              c0,0.6-0.4,1.1-0.9,1.1H94.9z" />
                            </g>
                          </g>
                        </svg>
                    </div>
                </div>

                <div v-if="item['_config'].icon == 'pro'" class="InputRadioIcons__icon" v-on:click="scrollTo()">
                    <div class="simple-svg-wrapper">
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
                          y="0px" viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve">
                          <g>
                            <g>
                              <path fill="#333333" d="M65.7,36.8H79l0.2,0c0.8-0.1,1.3-0.9,1.3-1.8c-0.1-0.5-0.3-1-0.6-1.3c-0.3-0.2-0.6-0.3-0.9-0.2l-13.3,0
                              c-0.6,0.1-1.2,0.7-1.3,1.5C64.3,36,64.9,36.8,65.7,36.8z" />
                              <path fill="#333333" d="M58,36.8l0.2,0c0.8-0.1,1.3-0.9,1.3-1.8c-0.1-0.5-0.3-1-0.6-1.3c-0.3-0.2-0.6-0.3-0.9-0.2l-13.3,0
                              c-0.6,0.1-1.2,0.7-1.3,1.5c-0.1,0.5,0.1,1,0.4,1.4c0.2,0.3,0.6,0.4,0.9,0.4H58z" />
                              <path fill="#333333" d="M65.7,49.6H79l0.2,0c0.8-0.1,1.3-0.9,1.3-1.8c-0.1-0.5-0.3-1-0.6-1.3c-0.3-0.2-0.6-0.3-0.9-0.2l-13.3,0
                              c-0.6,0.1-1.2,0.7-1.3,1.5C64.3,48.8,64.9,49.6,65.7,49.6z" />
                              <path fill="#333333" d="M57.9,46.2H45.6l0.1,0.2c0.5,1,0.8,2,1.1,3.1l0,0.1H58l0.2,0c0.8-0.1,1.3-0.9,1.3-1.8c-0.1-0.5-0.3-1-0.6-1.3
                              C58.6,46.3,58.3,46.2,57.9,46.2z" />
                              <path fill="#333333" d="M80,59.3C79.7,59.1,79.4,59,79,59l-13.2,0c-0.6,0.1-1.2,0.7-1.3,1.5c-0.1,1,0.6,1.7,1.3,1.8h13.3l0.2,0
                              c0.8-0.1,1.3-0.9,1.3-1.8C80.6,60,80.4,59.6,80,59.3z" />
                              <path fill="#333333" d="M58.2,62.4c0.8-0.1,1.3-0.9,1.3-1.8c0-0.8-0.6-1.5-1.2-1.5c-0.1,0-0.2,0-0.3,0l-12.2,0l0,0.1
                              c-0.4,0.7-0.8,1.5-1.3,2.2l0,0.1l0,0.1c0.2,0.6,0.7,1,1.2,1L58.2,62.4L58.2,62.4z" />
                              <path fill="#333333" d="M74,18.9V13c0-0.9-0.8-1.6-1.6-1.6h-8.8V5.7l0-0.2c-0.1-0.8-0.9-1.3-1.8-1.3c0,0,0,0,0,0
                              c-0.5,0.1-1,0.3-1.3,0.6c-0.2,0.3-0.3,0.6-0.2,0.9v5.7h-8.8c-0.9,0-1.6,0.8-1.6,1.6v8.5l-15.1,1.7l-0.1,0l0,14.1l0,0.1l0.3,0.1
                              c0.1,0,0.2,0.1,0.4,0.1c0.9,0.2,1.7,0.6,2.6,1l0.2,0.1V26.1l22.1-2.5l3.4-0.4l4.6-0.5l17.7-2v50l-16.3,1.9l-9.2,1l-8.8,1l-0.2,0
                              l0.3,0.4c0.2,0.3,0.5,0.5,0.7,0.8c0.4,0.6,0.8,1.2,1.3,1.9l0,0.1L89,73.8l0.1,0V17.2L74,18.9z M70.7,14.6v4.7l-10.2,1.1l-0.3,0
                              L53,21.1v-6.5H70.7z" />
                            </g>
                            <g>
                              <path fill="#CF2C4C" d="M31.4,65.7c1.2,0,2.4-0.2,3.5-0.5c1.1-0.3,2.1-0.8,3.1-1.3c3.8-2.3,6.3-6.4,6.3-11.1c0-4.7-2.5-8.8-6.3-11.1
                              c-1-0.6-2-1-3.2-1.4c0,0,0,0,0,0c-1.1-0.3-2.2-0.5-3.4-0.5c-7.1,0-12.9,5.8-12.9,12.9C18.5,59.9,24.3,65.7,31.4,65.7z M31.4,43
                              c1.2,0,2.4,0.2,3.4,0.6C36,44,37,44.7,38,45.5c2,1.8,3.3,4.4,3.3,7.4S40,58.5,38,60.3c-0.9,0.8-2,1.4-3.1,1.9
                              c-1.1,0.4-2.3,0.6-3.5,0.6c-5.5,0-9.9-4.4-9.9-9.9S25.9,43,31.4,43z" />
                              <path fill="#CF2C4C" d="M54.7,85.8c-0.6-2.8-1.7-5.5-3.2-7.8c-0.2-0.3-0.4-0.6-0.7-0.9c-0.5-0.7-1.1-1.3-1.7-1.9
                              c-0.3-0.3-0.6-0.6-0.9-0.9c-2.8-2.6-6.4-4.5-10.2-5.3c-1-0.2-2-0.4-3.1-0.4c0,0,0,0,0,0c-0.5,0-1-0.1-1.5-0.1
                              c-12,0-21.7,9.7-21.7,21.7v1.7l14.2-1.4l0.7-3.2l-11.8,1.2c0.8-9.5,8.9-17,18.6-17c0.5,0,1,0,1.6,0.1c1,0.1,2,0.3,3,0.5
                              c2.2,0.6,4.2,1.5,6,2.8c1.2,0.8,2.2,1.7,3.2,2.8c1.9,2,3.3,4.5,4.1,7.3l-13.6,1.3l0.7,2.9L55,87.3L54.7,85.8z" />
                              <polygon fill="#CF2C4C" points="36.4,78.8 34.9,76.7 34.2,75.7 30.3,75.7 27.6,80.3 30.3,84.4 27.8,96 36.8,95.1 35,87.8 34.7,86.4
                              34.7,86.4 34.2,84.4 37.6,80.3 		" />
                            </g>
                          </g>
                        </svg>
                    </div>
                </div>

                <div v-if="item['_config'].icon == 'candidat'" class="InputRadioIcons__icon" v-on:click="scrollTo()">
                    <div class="simple-svg-wrapper">
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
                          y="0px" viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve">
                          <path fill="#333333" d="M51.8,12.1l-34.1,3.6V92c0,0,60.3,0,60.4,0c5,0,9.1-4.1,9.1-9.1V8.4L51.8,12.1z M84.3,82.9
                          c0,3.5-2.8,6.3-6.3,6.3c-0.2,0-57.6,0-57.6,0V18.3L52.1,15l32.2-3.4V82.9z" />
                          <path fill="#CF2B4C" d="M69.9,31.5c1.6-1.9,1.8-4.7,0.3-6.9c-1.8-2.6-5.3-3.2-7.9-1.4c-1.2,0.9-2.1,2.2-2.4,3.6s0.1,3,0.9,4.2
                          c0.1,0.2,0.2,0.3,0.3,0.4C58,33,56,36.2,56,39.8v1.8h19v-1.8C75,36.3,73,33.1,69.9,31.5z M59.4,38.6c0.6-3,3.4-5.2,6.6-5
                          c2.9,0.2,5.2,2.3,5.8,5H59.4z M65.6,25.3c1.4,0,2.5,1.1,2.5,2.5s-1.1,2.5-2.5,2.5s-2.5-1.1-2.5-2.5c0-0.7,0.3-1.3,0.7-1.8
                          C64.3,25.6,64.9,25.3,65.6,25.3L65.6,25.3z" />
                          <g>
                            <path fill="#CF2B4C"
                              d="M73.5,51.8h-36c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h36.1c0.8,0,1.5-0.7,1.5-1.5S74.4,51.8,73.5,51.8z" />
                            <path fill="#CF2B4C" d="M31.6,51.8L31.6,51.8c-0.9,0-1.6,0.7-1.6,1.5s0.7,1.5,1.5,1.5h0.1c0.8,0,1.5-0.7,1.5-1.5S32.4,51.8,31.6,51.8z
                            " />
                          </g>
                          <g>
                            <path fill="#CF2B4C" d="M73.5,62.6h-36c-0.8,0-1.5,0.7-1.5,1.5c0,0.8,0.7,1.5,1.5,1.5h36.1c0.8,0,1.5-0.7,1.5-1.5
                            C75,63.2,74.4,62.6,73.5,62.6z" />
                            <path fill="#CF2B4C" d="M31.6,62.6L31.6,62.6c-0.9,0-1.6,0.7-1.6,1.5c0,0.8,0.7,1.5,1.5,1.5h0.1c0.8,0,1.5-0.7,1.5-1.5
                            C33.1,63.2,32.4,62.6,31.6,62.6z" />
                          </g>
                          <g>
                            <path fill="#CF2B4C" d="M73.5,73.6h-36c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h36.1c0.8,0,1.5-0.7,1.5-1.5
                            C75,74.3,74.4,73.6,73.5,73.6z" />
                            <path fill="#CF2B4C" d="M31.6,73.6L31.6,73.6c-0.9,0-1.6,0.7-1.6,1.5s0.7,1.5,1.5,1.5h0.1c0.8,0,1.5-0.7,1.5-1.5
                            C33.1,74.3,32.4,73.6,31.6,73.6z" />
                          </g>
                        </svg>
                    </div>
                    <!--<simple-svg :filepath="getURL(item['_config'].icon)"/>-->
                </div>

                <div class="Input InputRadioIcons__content">
                    <div class="InputRadioIcons__title" v-html="key"></div>
                    <div class="text">
                        {{ item["_config"] ? item["_config"].text : "" }}
                        <div v-if="item['_config'].text == '6 véhicules minimum hors engin'" class="tooltip -forradio">
                            <svg version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="16px" height="16px" xmlns="http://www.w3.org/2000/svg">
                              <g transform="matrix(1 0 0 1 -602 -170 )">
                                <path
                                  d="M 14.0606916876048 8.6858082036554  C 14.0216829107907 8.9001373257015  14.1632540895656 9.10438552789675  14.3771449107486 9.14383260557395  C 14.5919123336578 9.17977327634651  14.7957222349899 9.04039360188708  14.8351693126671 8.82694108156715  C 14.9158166714738 8.38469551071948  14.9565786517403 7.93105411743173  14.9565786517403 7.47828932587013  C 14.9561403508772 3.35475480601395  11.6013855448632 0  7.47828932587013 0  C 3.35475480601395 0  0 3.35475480601395  0 7.47828932587013  C 0 11.6018238457263  3.35475480601395 14.9565786517403  7.47828932587013 14.9565786517403  C 9.78375186567068 14.9565786517403  11.9248515818162 13.9173673053777  13.3537123954569 12.104554935679  C 13.4882707604224 11.9340558999409  13.4589046025961 11.6864159123008  13.288405566858 11.5522958481983  C 13.1179065311199 11.4172991823697  12.8702665434797 11.4462270393329  12.7357081785142 11.6180409776603  C 11.4571845609099 13.239315870193  9.54093318752439 14.1698286025118  7.47828932587013 14.1698286025118  C 3.78911096132618 14.1698286025118  0.787188350091594 11.1683442921402  0.787188350091594 7.47872762673322  C 0.787188350091594 3.78911096132618  3.7886726604631 0.787188350091592  7.47828932587013 0.787188350091592  C 11.1679059912772 0.787188350091592  14.1693903016487 3.78867266046311  14.1693903016487 7.47828932587013  C 14.1693903016487 7.88415592508217  14.13257302915 8.29046082515729  14.0606916876048 8.6858082036554  Z M 6.8859649122807 9.84862039340651  C 6.880008647766 10.0660176214942  7.05620559472414 10.2422145684523  7.2736028228118 10.2422145684523  C 7.49100005089946 10.2422145684523  7.66719699785759 10.0660176214942  7.63157894736842 9.84862039340651  L 7.63157894736842 9.39673220357108  C 7.66675869699452 9.08422368819508  7.86048767847585 8.80634094100239  8.13837042566854 8.72131057356488  C 9.60711661784946 8.27205218890793  10.4749523267478 6.78708886479305  10.1576225018779 5.26837637422102  C 9.92532304444551 4.15640708458718  9.02286156736389 3.25219240405324  7.91176887945621 3.01770144230547  C 6.87737884258752 2.80030421421781  5.83553769104648 3.12245534858157  5.12329878854155 3.88115414257297  C 4.97427649509437 4.03938075414483  4.98216591062981 4.28877394523733  5.14039252220168 4.43735793782143  C 5.29905743463662 4.58638023126861  5.54801232486603 4.57849081573317  5.69659631745013 4.42026420416131  C 6.21948924710451 3.86362210804977  6.98651575749443 3.62606304026044  7.74915925925355 3.78823435960002  C 8.55957755508838 3.9591716962012  9.21746715057139 4.61881449513653  9.38708958458333 5.42967109183444  C 9.62070394460494 6.5477765935514  8.98516769313901 7.63958404348356  7.90826247255157 7.96918629251968  C 7.30296898063816 8.1545875576025  6.880008647766 8.74191071412964  6.8859649122807 9.39673220357108  L 6.8859649122807 9.84862039340651  Z M 6.76035251214517 11.2805493130887  C 6.76035251214517 11.5715810861738  6.99747327907143 11.8087018531001  7.28850505215651 11.8087018531001  C 7.5795368252416 11.8087018531001  7.81665759216786 11.5715810861738  7.81665759216786 11.2805493130887  C 7.81665759216786 10.9895175400036  7.57953682524161 10.7528350739405  7.28850505215651 10.7528350739405  C 6.99703497820835 10.7528350739405  6.76035251214517 10.9895175400036  6.76035251214517 11.2805493130887  Z "
                                  fill-rule="nonzero" fill="#818181" stroke="none" transform="matrix(1 0 0 1 602 170 )" />
                              </g>
                            </svg>
                            <div class="tooltiptext">
                              {{ 'Pour les flottes de moins de 6 véhicules (hors engins), nous vous invitons à sélectionner' }}
                                <span class="bold">{{ 'Mon message concerne « Une assurance pour les particuliers »' }}</span>
                              {{ 'au début du formulaire.' }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="InputRadioIcons__circle">
                    <div class="InputRadioIcons__round"></div>
                </div>

            </el-radio-button>

            <button class="button button--see-more js-see-more" data-title-more="Voir plus" data-title-less="Voir moins">{{ "Voir plus" }}</button>
        </el-radio-group>
    </div>
</template>

<style lang="sass">
    @import ../../../common/styles/mixins
    @import ../../../common/styles/settings

    .InputRadioIcons

        //overide style
        .el-radio-button:first-child .el-radio-button__inner,
        .el-radio-button__inner
            border: 0
            outline: none
        .el-radio-button__orig-radio:checked+.el-radio-button__inner
            background-color: inherit
            color: inherit
            box-shadow: none
            .InputRadioIcons__circle
                .InputRadioIcons__round
                    background-color: $color-base2
        // .el-radio-button:focus:not(.is-focus):not(:active):not(.is-disabled)
        //     box-shadow: none
        .el-radio-group
            display: flex
            +media("<1024px")
                flex-direction: column


        //style
        &__item
            flex-basis: 25%
            margin: 0 0.9375rem
            border: 1px solid $color-gray-dark
            border-radius: 2px
            // overflow: hidden
            +media("<1024px")
                margin: 0 0 20px

            &:nth-child(n + 9)
                display: none

            &:focus
                border: 1px solid #1b76c4

            &:hover
                box-shadow: 0 0 4px rgba(0,0,0,0.4)

            &.is-active
                background-color: rgba(206, 14, 74, 0.05)

            &:first-child
                margin-left: 0

            &:last-child
                margin-right: 0

            .el-radio-button__inner
                white-space: inherit
                display: flex
                flex-direction: column
                align-items: center
                height: 100%
                padding: 1.25rem

                +media("<1024px")
                    flex-flow: row-reverse nowrap
                    justify-content: flex-end

        &__content
            width: 100%
            margin-bottom: 0.75rem
            +media("<1024px")
                text-align: left
                margin-left: 20px
                margin-bottom: 0

        &__circle
            display: flex
            justify-content: center
            align-items: center
            width: 24px
            height: 24px
            margin-top: auto
            border: 1px solid $color-gray-dark
            background-color: $color-white
            border-radius: 50%
            +media("<1024px")
                flex-shrink: 0
                margin-top: 0

        &__round
            width: 14px
            height: 14px
            background-color: transparent
            border-radius: 50%

        &__icon
            display: flex
            align-items: center
            justify-content: center
            width: 3.75rem
            height: 3.75rem
            margin-bottom: 0.625rem
            background-color: transparent
            transition: background-color $speed-fast $authentic-motion
            +media("<1024px")
                display: none
                // width: 3.125rem
                // height: 3.125rem


            .simple-svg-wrapper
                width: 100%
                height: 100%
                svg
                    width: 100%
                    height: 100%
                    transition: stroke $speed-fast $authentic-motion

        &__title
            font-size: 16px
            font-weight: 400
            line-height: 24px
            margin-bottom: 0.5rem
            color: $color-text
            +media("<1024px")
                margin-bottom: 0

        .text
            font-weight: 400
            line-height: 1.3
            color: $color-gray-dark



</style>

<script>
    import $ from "jquery";

    export default {
        props: ["value", "items"],
        data() {
            return {
                localModel: this.value
            }
        },
        watch: {
            localModel: function(val) {
                this.$emit("input", val);
                this.$emit("change");

                if (!$(this.$el).closest('.node-contact__section').hasClass('level1') && !$(this.$el).closest('.node-contact__section').hasClass('level2')) {
                    $('.el-radio-button').removeAttr('style');
                    $('.js-see-more').html($('.js-see-more').data('titleMore'));
                }
            },
            value: function(newVal, oldVal) {
                this.localModel = newVal;
            }
        },

        mounted() {
            if ($(this.$el).closest('.node-contact__section').hasClass('level1')) {
                $('.js-see-more').on('click', function(){
                    var $listOptions = $(this).closest('.node-contact__section').find('.el-radio-button');
                    var $listOptionsVisible = $(this).closest('.node-contact__section').find('.el-radio-button:visible');
                    var allOptionsDisplayed = $listOptions.length == $listOptionsVisible.length;

                    if (allOptionsDisplayed) {
                        for (let i = 8; i < $listOptions.length; i++) {
                            $($listOptions[i]).removeAttr('style').hide()

                            if ($($listOptions[i]).hasClass('is-active')) {
                                $($listOptions[i]).find('input').prop('checked', false);
                                $($listOptions[i]).removeClass('is-active');
                                $($listOptions[i]).closest('.node-contact__section').nextAll('[class*="node-contact__"]').hide();
                            }
                        }
                        $listOptions[7].focus();
                        $(this).html($(this).data('titleMore'));
                    } else {
                        for (let i = 8; i < $listOptions.length; i++) {
                            $($listOptions[i]).show()
                        }
                        $listOptions[8].focus();
                        $(this).html($(this).data('titleLess'));
                    }
                });
            }
        },

        methods: {
            getURL(iconName) {
                const iconURL = require(`../../../common/graphics/${iconName}.svg`);
                return `${window.baseUrl}${iconURL}`;
            },
            scrollTo() {
                //$("html, body").animate({
                //    scrollTop: 1275
                //}, 900);
            }
        }
    }

</script>
